/*
  Y2K açılır menü — "A: tam genişlik şerit" (2026-11-02). header-dropdown-menu.liquid'deki
  <header-menu><details> yapısına ince katman; Dawn'ın markup'ı aynen. Stil: y2k-siyah.css "AÇILIR MENÜ".
  - Fareli cihazda başlığın üstüne gelince şerit açılır; başlıktan/şeritten çıkınca 150ms sonra kapanır
    (başlıktan şeride inerken kapanmaz — CSS'teki görünmez köprü + bu gecikme). Başka başlığa geçince
    öbürü anında kapanıp bu açılır: tek şerit, titreme yok (CSS'te animasyon kapalı).
  - Klavye: Tab ile başlığa gelince açılır, odak menüden çıkınca kapanır; Esc kapatır ve odak şeritteyse
    başlığa döner.
  - Başlığa tıklama (fare, dokunma ya da Enter) doğrudan kategorinin koleksiyonuna gider.
  - Hizalama: şeridin sol boşluğu = ilk menü öğesinin ("YENİ GELENLER") header'a göre solu; sağ boşluk =
    ikonların sağ kenarı; açık başlığın pembe çizgisi header'ın alt kenarına oturur. Yüklemede, yeniden
    boyutlanınca ve her açılışta ölçülür (menü iki satıra düştüğünde de doğru yer).
*/
(function () {
  'use strict';

  if (window.__y2kMenu) return;
  window.__y2kMenu = true;

  var SEL = '.header__inline-menu header-menu > details';

  function hizala() {
    var hw = document.querySelector('.header-wrapper');
    var ilk = document.querySelector('.header__inline-menu > ul > li');
    if (!hw || !ilk) return;
    var h = hw.getBoundingClientRect();
    var ikon = document.querySelector('.header__icons');
    hw.style.setProperty('--y2k-serit-sol', Math.max(0, Math.round(ilk.getBoundingClientRect().left - h.left)) + 'px');
    if (ikon) hw.style.setProperty('--y2k-serit-sag', Math.max(0, Math.round(h.right - ikon.getBoundingClientRect().right)) + 'px');
    document.querySelectorAll(SEL + ' > summary > span').forEach(function (sp) {
      var alt = (h.bottom - sp.getBoundingClientRect().bottom).toFixed(2); // ondalıklı: yuvarlama çizgiyi 1px şeridin altına itiyordu
      sp.parentElement.style.setProperty('--y2k-cizgi-alt', alt + 'px');
    });
  }

  function kapat(d) {
    if (!d.hasAttribute('open')) return;
    d.removeAttribute('open');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
  }

  function ac(d) {
    document.querySelectorAll(SEL + '[open]').forEach(function (o) {
      if (o !== d) kapat(o);
    });
    if (d.hasAttribute('open')) return;
    hizala();
    d.setAttribute('open', '');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(SEL + '[open]').forEach(function (d) {
      var icerde = d.contains(document.activeElement);
      kapat(d);
      if (icerde) d.querySelector('summary').focus();
    });
  });

  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function kur() {
    hizala();
    document.querySelectorAll(SEL).forEach(function (d) {
      if (d.dataset.y2kMenu) return;
      d.dataset.y2kMenu = '1';
      var li = d.closest('li');
      var s = d.querySelector('summary');
      var zaman;

      if (FINE) {
        li.addEventListener('mouseenter', function () {
          clearTimeout(zaman);
          ac(d);
        });
        li.addEventListener('mouseleave', function () {
          zaman = setTimeout(function () {
            if (!d.contains(document.activeElement) || document.activeElement === s) kapat(d);
          }, 150);
        });
      }

      // Klavye: odak menü öğesine girince aç, menüden tamamen çıkınca kapat
      li.addEventListener('focusin', function () {
        clearTimeout(zaman);
        if (li.matches(':focus-within') && document.activeElement && document.activeElement.matches(':focus-visible')) ac(d);
      });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) kapat(d);
      });

      // Başlığa tıklama → kategorinin koleksiyonu (paneli aç-kapa yerine)
      if (s && s.dataset.y2kUrl) {
        s.addEventListener('click', function (e) {
          e.preventDefault();
          window.location.href = s.dataset.y2kUrl;
        });
      }
    });
  }

  var bekle;
  window.addEventListener('resize', function () {
    clearTimeout(bekle);
    bekle = setTimeout(hizala, 120);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
  window.addEventListener('load', hizala);
})();
